<template>
	<div class="fuel container-fluid py-3">
		<div class="row">
			<div class="col-md-12 p-0">				
				
				<div class="row">
					<OverviewBright />
				</div>

				<Footer/>
			</div>
		</div>
	</div>
</template>

<script>
import OverviewCustomer from '@/views/pages/OverviewCustomer.vue'
import OverviewFuel from '@/views/pages/OverviewFuel.vue'
import OverviewFuelCoco from '@/views/pages/OverviewFuelCoco.vue'
import OverviewFuelKso from '@/views/pages/OverviewFuelKso.vue'
import OverviewBright from '@/views/pages/OverviewBright.vue'
//import OverviewBrightPertumbuhan from '@/views/pages/OverviewBrightPertumbuhan.vue'
import OverviewLPG from '@/views/pages/OverviewLPG.vue'
import OverviewNFR from '@/views/pages/OverviewNFR.vue'
import OverviewSupport from '@/views/pages/OverviewSupport.vue'
import OverviewFinance from '@/views/pages/OverviewFinance.vue'
import OverviewCafe from '@/views/pages/OverviewCafe.vue' 
import OverviewMaintenance from '@/views/pages/OverviewMaintenance.vue'
import Footer from '@/views/Footer.vue'
import { AxiosWithJar, Config} from '@/utility.js'

export default{
	components:{
		OverviewBright,
		/*
		OverviewCustomer,
		OverviewFuel,
		OverviewLPG,
		OverviewNFR,
		OverviewSupport,
		OverviewFinance,
		OverviewCafe,
		OverviewMaintenance,
		Footer,
		OverviewFuelCoco,
		OverviewFuelKso,      
		*/   
	},
    mounted() {

		this.$store.state.page=window.location.pathname.split('/')[1]===''?'overview':window.location.pathname.split('/')[1];
		//document.title=this.$store.state.page+' - Dashboard'

		let userRoles = String(this.$store.getters.getLoginInfo.userroles); //",MOD2022040002_1";
		this.userRolesList = userRoles.split(',');

		this.getSatgasTitle();
		//console.log(this.userRolesList.length)
    },
	data(){
		return {
			satgasTitle: 'DASHBOARD SATGAS',
			userRolesList: [],
		}
	},
    methods:{
		async getSatgasTitle() {
			//GET SATGAS TITLE
			let url =Config().apiURL + '/v1/fuel2/satgastitle?'
			AxiosWithJar().get(url)
			.then((response)=>{ 
				this.satgasTitle = response.data.data[0].Value;
			})
		},
	}
}

</script>
<style>
.banner_satgas {
	background-color: #ffff66;
	color: #000000;
	font-weight: bold;
	padding: 10px;
	cursor: pointer;
	border-radius:5px;
}
</style>

